<div class="user-security">
    <div hidden class="two-factor-authentication">
        <div>
            <span class="aum-typo-paragraph-l">
                {{ 'aumico_users_edit_user_security_authentication' | i18next }}
            </span>
        </div>
        <div>
            <button aum-button color="basic">
                {{ 'aumico_users_edit_user_security_enable_two_factor_authentication' | i18next }}
            </button>
        </div>
        <div class="divider"></div>
    </div>
    <form class="form-container" [formGroup]="changePasswordFormGroup" (ngSubmit)="onChangePassword()">
        <div class="form-row header-row">
            <span class="aum-typo-paragraph-l">
                {{ 'aumico_users_edit_user_security_change_password' | i18next }}
            </span>
        </div>
        <div class="form-row">
            <aum-password-input
                placeholder="{{ 'aumico_users_edit_user_security_enter_current_password' | i18next }}"
                [aumFormControl]="changePasswordFormGroup.controls['oldPassword']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_security_current_password' | i18next
                }}</aum-form-field-label>
            </aum-password-input>
        </div>
        <div class="form-row">
            <aum-password-input
                class="password form-col"
                placeholder="{{ 'aumico_users_edit_user_security_enter_new_password' | i18next }}"
                [aumFormControl]="changePasswordFormGroup.controls['newPassword']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_security_new_password' | i18next
                }}</aum-form-field-label>
            </aum-password-input>
            <aum-password-input
                class="form-col"
                placeholder="{{ 'aumico_users_edit_user_security_confirm_new_password' | i18next }}"
                [aumFormControl]="changePasswordFormGroup.controls['confirmNewPassword']"
            >
                <aum-form-field-label>{{
                    'aumico_users_edit_user_security_repeat_new_password' | i18next
                }}</aum-form-field-label>
            </aum-password-input>
        </div>
        <div class="form-row">
            <div *ngIf="showPasswordConstraints" class="password-strength-container">
                <mat-password-strength
                    class="aum-password-strength"
                    #passwordComponent
                    [password]="passwordChange"
                    enableLengthRule="true"
                    min="8"
                    max="32"
                    warnThreshold="8"
                    [customValidator]="passwordValidatorRegex"
                ></mat-password-strength>
                <mat-password-strength-info
                    class="aum-password-strength-info"
                    *ngIf="changePasswordFormGroup"
                    password="passwordChange"
                    [passwordComponent]="passwordComponent"
                    [lowerCaseCriteriaMsg]="'aumico_users_registration_password_lower_case_criteria_message' | i18next"
                    [upperCaseCriteriaMsg]="'aumico_users_registration_password_upper_case_criteria_message' | i18next"
                    [digitsCriteriaMsg]="'aumico_users_registration_password_digits_criteria_message' | i18next"
                    [specialCharsCriteriaMsg]="
                        'aumico_users_registration_password_special_char_criteria_message' | i18next
                    "
                    [minCharsCriteriaMsg]="'aumico_users_registration_password_min_chars_criteria_message' | i18next"
                    [customCharsCriteriaMsg]="
                        'aumico_users_registration_password_special_char_criteria_message' | i18next
                    "
                ></mat-password-strength-info>
            </div>
        </div>
        <div class="form-row footer-row">
            <button aum-button color="basic" type="submit" [disabled]="!changePasswordFormGroup.valid">
                {{ 'aumico_users_edit_user_security_change_password' | i18next }}
            </button>
        </div>
    </form>
</div>
